
(function(){
  function cleanup(){
    var phrases = [
      'Quality product',
      'Lightning, Fast shipping. Guaranteed.',
      'Free 30 day return',
      'Shop risk-free with easy return.'
    ];
    document.querySelectorAll('.product__info-container *').forEach(function(el){
      var text = (el.textContent || '').replace(/\s+/g,' ').trim();
      if(!text) return;
      if(phrases.some(function(p){ return text.indexOf(p) >= 0; })){
        var block = el.closest('.icon-with-text, .product__accordion, .product__text, .product__info-container > div, li') || el;
        block.style.display = 'none';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', cleanup);
  document.addEventListener('shopify:section:load', cleanup);
  setTimeout(cleanup, 600);
})();
